import React from 'react';
import { Layers, Sparkles, LineChart, CalendarDays, Users } from 'lucide-react';
import { ANNUAL_MONTHLY_EQUIVALENT } from '../config/pricing';

const BENEFITS = [
  { icon: Layers, text: 'Access to 6 more exclusive categories' },
  { icon: CalendarDays, text: 'Unlock 250+ past games across all categories' },
  { icon: Sparkles, text: 'Analyze all stock categories with Baron Wuffett' },
  { icon: LineChart, text: 'Increase the total number of stocks in your Paper Portfolio to 10' },
  { icon: Users, text: 'Create infinite private leaderboards with your friends' },
];

interface MembershipBenefitsTextProps {
  size?: 'sm' | 'lg';
}

export const MembershipBenefitsText: React.FC<MembershipBenefitsTextProps> = ({ size = 'sm' }) => {
  const isLg = size === 'lg';

  return (
    <div className={isLg ? 'space-y-4' : 'space-y-3'}>
      <p className={`${isLg ? 'text-lg' : 'text-sm'} font-semibold text-foreground`}>
        From just {ANNUAL_MONTHLY_EQUIVALENT}/mo
      </p>
      {BENEFITS.map(({ icon: Icon, text }) => (
        <div key={text} className={`flex items-start ${isLg ? 'gap-4' : 'gap-3'}`}>
          <Icon className={`${isLg ? 'w-7 h-7' : 'w-5 h-5'} text-amber-500 shrink-0 mt-0.5`} />
          <span className={`${isLg ? 'text-lg' : 'text-sm'} text-foreground`}>{text}</span>
        </div>
      ))}
    </div>
  );
};
